import axios from 'axios';

// Create an axios instance for API requests
const api = axios.create({
  // Set the base URL for all API requests
  // In production build mode, use empty string to use same domain as backend
  baseURL: process.env.REACT_APP_BUILD_MODE === 'production' 
    ? '/api' 
    : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api'),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Store for dispatch function
let store;

// Function để set store từ component chính
export const setApiStore = (storeInstance) => {
  store = storeInstance;
};

// Add a request interceptor to add the token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (e.g., token expired)
    if (error.response && error.response.status === 401) {
      // Clear token
      localStorage.removeItem('token');
      
      // Dispatch action để hiển thị popup nếu store có sẵn
      if (store) {
        const { handleTokenExpired } = require('../redux/slices/authSlice');
        store.dispatch(handleTokenExpired());
      }
    }
    return Promise.reject(error);
  }
);

// Lấy dữ liệu chung (sellerAccounts, categories)
export const fetchDataCommon = () => api.get('/datacommon');

export default api;